import { scrollTop, onScroll } from '../utils/scroll';

export function setupFixedNavigation() {
    const fixedNavigation = document.querySelector('.fixed-navigation');

    if (fixedNavigation) {
        onScroll(() => {
            if (scrollTop > 10) {
                fixedNavigation.classList.add('fixed-navigation--white');
            } else {
                fixedNavigation.classList.remove('fixed-navigation--white');
            }
        });
    }
}
